export default __webpack_public_path__ + "static/media/radiopublic_podcast.75eb87bc.svg";